import WorkoutsHub from './workouts/WorkoutsHub';

export default WorkoutsHub;
